
import { SvgIconProps, useTheme } from "@mui/material";
import { IconTypes } from "./types";
import { icon2iconUrl } from "./constant";

export type CustomIconProps = {
  icon: IconTypes;
};

export const SmallCustomIcon = (props: CustomIconProps & SvgIconProps) => {
  const theme = useTheme();
  const Res = icon2iconUrl[props.icon];
  const IconComponent = Res.type;
  const stroke = props.stroke ? props.stroke : theme.palette.primary.dark;

  return <IconComponent width={12} height={12} {...props} stroke={stroke} />;
};
